import { connect } from 'react-redux';
import {
    getIsComparateurApporteur,
    getParrainageEmailInit,
    getTypeMERInit,
} from '../../../../../../redux/selectors/init/init.selectors.js';
import EmailClient from './EmailClient';

const mapStateToProps = (state) => {
    return {
        isComparateur: getIsComparateurApporteur(state),
        emailParrainage: getParrainageEmailInit(state),
        isAppGPT: ['AppGPT', 'AgentConv'].includes(getTypeMERInit(state)),
    };
};

const EmailClientContainer = connect(mapStateToProps)(EmailClient);

export default EmailClientContainer;
